var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[_c('h1',{staticClass:"msg"},[_vm._v(_vm._s(_vm.msg))]),_c('p',[_vm._v(" Freelancing Coder and Photographer ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }